"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PromoCodeTemplateAmountsEdit_1 = require("./PromoCodeTemplateAmountsEdit");
var PromoCodeTemplateAmountsList_1 = require("./PromoCodeTemplateAmountsList");
var PromoCodeTemplateAmounts = /** @class */ (function (_super) {
    __extends(PromoCodeTemplateAmounts, _super);
    function PromoCodeTemplateAmounts(props) {
        return _super.call(this, props) || this;
    }
    PromoCodeTemplateAmounts.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AC = this.props.listAppCurrency.Subscribe("*", function (id, data) {
            _this.setState({ availCurrency: data.data });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            availCurrency: []
        }, function () {
            _this.props.listAppCurrency.LoadData();
        });
        this.props.state.setExtBreadCrumbPath(["Промокоды", "Суммы шаблонов промокодов"]);
    };
    PromoCodeTemplateAmounts.prototype.componentWillUnmount = function () {
        this.props.listAppCurrency.UnSubscribe(this.SID_AC);
    };
    PromoCodeTemplateAmounts.prototype.onGoBackToTopPageClick = function () {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    PromoCodeTemplateAmounts.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    PromoCodeTemplateAmounts.prototype.onEditClick = function (item) {
        this.setState({ edit_mode: "EDIT", record: item });
    };
    PromoCodeTemplateAmounts.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    PromoCodeTemplateAmounts.prototype.getBrandCountriesRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(PromoCodeTemplateAmountsEdit_1.default, { state: this.props.state, data: this.props.dataAmounts, rootRecord: this.props.record, onGoBack: this.onGoBackClick.bind(this), availCurrency: this.state.availCurrency, record: null }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(PromoCodeTemplateAmountsEdit_1.default, { state: this.props.state, data: this.props.dataAmounts, rootRecord: this.props.record, onGoBack: this.onGoBackClick.bind(this), availCurrency: this.state.availCurrency, record: this.state.record }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(PromoCodeTemplateAmountsList_1.default, { state: this.props.state, data: this.props.dataAmounts, rootRecord: this.props.record, onGoBackClick: this.onGoBackToTopPageClick.bind(this), onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this) }));
        }
    };
    PromoCodeTemplateAmounts.prototype.render = function () {
        return (React.createElement("div", null, this.getBrandCountriesRenderObject()));
    };
    return PromoCodeTemplateAmounts;
}(React.Component));
exports.default = PromoCodeTemplateAmounts;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_promocodes/ui/component/amounts/PromoCodeTemplateAmounts.tsx
// module id = 1973
// module chunks = 0